export const filterNotConfirmedTerms = (terms) => terms.filter((term) => term.confirmed);